<template>
  <div class="main">
    <div class="container">
      <div>
        <div class="title">支付成功</div>
        <div class="title2">订单号：{{ orderid }}</div>
        <div>
          <button class="btn gradient-btn" @click="goToOrderDetails">
            确定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  name: "cancel",
  data() {
    return {
      orderid: "",
    };
  },
  created() {
    this.orderid = this.$route.query.out_trade_no;
  },
  methods: {
    goToOrderDetails() {
      if (this.is_weixn()) {
        // this.$router.push({
        //   path: "/paymentCallbackJump",
        // });
        window.location.href = "/#/paymentCallbackJump";
      } else {
        if (Cookies.get("token")) {
          window.location.href = "/#/paymentCallbackJump";
        } else {
          this.$toast("请您手动退回微信！");
        }
      }
    },
    is_weixn() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  // background-color: rgba($color: #000000, $alpha: 0.3);
  // svg {
  //   width: 50px;
  //   height: 50px;
  //   position: relative;
  //   top: 50%;
  //   margin-top: -25px;
  //   left: 50%;
  //   margin-left: -25px;
  // }
  .container {
    height: 800rpx;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    .title {
      font-size: 20px;
      height: 80px;
      font-weight: 400;
      color: #000;
      line-height: 80px;
      text-align: center;
      margin-top: -100px;
    }
    .title2 {
      font-size: 14px;
      height: 30px;
      font-weight: 400;
      color: #000;
      line-height: 36rpx;
      margin: 24rpx 0 48rpx 0;
    }
    .btn {
      width: 122px;
      height: 36px;
      background: linear-gradient(180deg, #17e1eb, #00cdd7);
      border-radius: 36px;
      color: #fff;
      font-weight: 500;
      font-size: 15px;
      margin-top: 30px;
    }
  }
}
</style>
<style>
/* @-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}
svg {
  -webkit-transform: rotate(360deg);

  animation: rotation 3s linear infinite;

  -moz-animation: rotation 3s linear infinite;

  -webkit-animation: rotation 3s linear infinite;

  -o-animation: rotation 3s linear infinite;
} */
</style>
